import React, { useContext, useRef, useEffect } from "react";

import { AnchorContext } from "./anchor-context";

interface TProps extends React.HTMLAttributes<HTMLElement> {
  id: string;
}

export function AnchorSection({ children, ...attributes }: TProps) {
  const { registerSection, unregisterSection } = useContext(AnchorContext);
  const ref = useRef<HTMLElement>(null);

  // Logic to register/unregister component
  // when added/removed from DOM
  useEffect(() => {
    if (ref.current) {
      // Scrolling to the section targeted by the URL hash is handled
      // by AnchorProvider once the page has settled
      registerSection(ref.current);
    }

    return () => {
      if (ref.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        unregisterSection(ref.current);
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <b {...attributes} ref={ref}></b>
      {children}
    </>
  );
}
